import Item from "./Item";

export default class Order {
	/**
	 * Order ID
	 */
	id?: string = undefined;

	/**
	 * Order currency code alpha-3
	 */
	currency?: string = undefined;

	/**
	 * Order total amount
	 */
	amount?: number = undefined;

	/**
	 * Order total tax amount
	 */
	tax_amount?: number = undefined;

	/**
	 * Order total shipping amount
	 */
	shipping_amount?: number = undefined;

	/**
	 * Order summary of items or products
	 */
	content?: Array<Item> = undefined;

	/**
	 * Order extra properties
	 */
	extras?: Record<string, any> = undefined;

	/**
	 * Order note or aditional instructions
	 */
	note?: string = undefined;

	/**
	 * Order calback webhook URL
	 */
	callback_url?: string = undefined;

	/**
	 * Order customer name
	 */
	customer_name?: string = undefined;

	/**
	 * Order customer email
	 */
	customer_email?: string = undefined;

	/**
	 * Initialize model
	 */
	constructor() {
		this.content = [];
		this.extras = {};
	}

	/**
	 * Add item to content list of products/items
	 *
	 * @param item
	 * @return
	 */
	addItem(item: Item): Order {
		this.content?.push(item);
		this.totalize();

		return this;
	}

	/**
	 * Add extra property to order
	 *
	 * @param key
	 * @param value
	 * @return
	 */
	addExtra(key: string, value: any): Order {
		if (this.extras === undefined) {
			this.extras = {};
		}

		this.extras[key] = value;

		return this;
	}

	/**
	 * Totalize order amounts and items
	 *
	 * @return
	 */
	totalize(): Order {
		if (!this.content?.length) {
			return this;
		}

		this.amount = 0.00;
		this.tax_amount = 0.00;

		this.content.forEach(item => {
			item.totalize();

			this.amount ??= 0.00;
			this.amount += item.total ?? 0.00;

			this.tax_amount ??= 0.00;
			this.tax_amount += (item.tax ?? 0.00) * (item.qty ?? 0.00);
		});

		return this;
	}
}
